import axios from 'axios'
import {API_BASE} from '../api'
import {apiErrorHandler, ApiFilter} from '../api'
import Auth from '../auth'

const SURVEY_ENDPOINT = `${API_BASE}surveys/`

export default class SurveyAPI {
  constructor(cls) {
    this.cls = cls
  }
  static create(cls) {
    return new SurveyAPI(cls)
  }

  list({pagination, filters}) {
    const filtersMap = {
      // Pagination
      page: ApiFilter.create({key: 'page'}),
      pageSize: ApiFilter.create({key: 'page_size'}),

      // Sorting
      ordering: ApiFilter.create({key: 'ordering'}),

      // Filtering
      name: ApiFilter.create({key: 'name'}),
    }
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: ApiFilter.buildParams(filtersMap, {...pagination, ...filters}),
    }
    const promise = axios
      .get(SURVEY_ENDPOINT, options)
      .then(res => res.data)
      .then(data => {
        data.results = data.results.map(this.cls.fromAPI)
        return data
      })
      .catch(apiErrorHandler({apiName: 'Survey List API Error'}))
    return promise
  }

  retrieve(surveyId) {
    const url = `${SURVEY_ENDPOINT}${surveyId}/`
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    const promise = axios
      .get(url, options)
      .then(res => this.cls.fromAPI(res.data))
      .catch(apiErrorHandler({apiName: 'Survey Retrieve API Error', rethrowError: true}))
    return promise
  }
}
